import { createFileRoute } from '@tanstack/react-router'

import { WorkflowDetailsPage } from '@/pages/workflow-details/WorkflowDetails.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/workbench/$workflowId',
)({
  component: WorkflowDetailsPage,
})
